import Particles from "./components/Particles";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Services from "./components/Services";
import Products from "./components/Products";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <>
      <Particles />
      <Nav />
      <main>
        <Hero />
        <Services />
        <Products />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
